import { render, staticRenderFns } from "./CxHeader.vue?vue&type=template&id=8cdbf7ac&scoped=true&"
import script from "./CxHeader.vue?vue&type=script&lang=js&"
export * from "./CxHeader.vue?vue&type=script&lang=js&"
import style0 from "./CxHeader.vue?vue&type=style&index=0&id=8cdbf7ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdbf7ac",
  null
  
)

export default component.exports